module.exports = __webpack_public_path__ + "static/media/questionierCompleted.82b5a4ec.png";